<div class="userprofile-tabview">
  <p-tabs [(value)]="tabIndex">
    <p-tablist>
      <p-tab [value]="0">User Profile</p-tab>
      @if (!isAppWide) {
        <p-tab [value]="1">User Settings</p-tab>
      }
      @if (!isAppWide) {
        <p-tab [value]="2" *checkAccess="Claims.manage_email_notifications">User Notifications</p-tab>
      }
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        <myuserinformation #myInfoComp />
      </p-tabpanel>
      @if (!isAppWide) {
        <p-tabpanel [value]="1">
          <myusersettings #mySettingsComp [appWideRoleStatus]="isAppWide" />
        </p-tabpanel>
      }
      @if (!isAppWide) {
        <p-tabpanel [value]="2" *checkAccess="Claims.manage_email_notifications">
          <myusernotifications #myNotificationsComp />
        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</div>
